import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Datastore } from '@freelancer/datastore';
import type { SiteStatsCollection } from '@freelancer/datastore/collections';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-home-page-make-it-real',
  template: `
    <fl-section-homepage-feature
      [srcImageAnimationMobile]="'home/make-it-real/make-it-real-cards-m.png'"
      [srcImageAnimationTablet]="'home/make-it-real/make-it-real-cards-t.png'"
      [srcImageAnimationLargeDesktop]="
        'home/make-it-real/make-it-real-cards-ld.png'
      "
      [srcBackgroundMobile]="'home/make-it-real/make-it-real-bg-m.png'"
      [srcBackgroundTablet]="'home/make-it-real/make-it-real-bg-t.jpg'"
      [srcBackgroundLargeDesktop]="'home/make-it-real/make-it-real-bg-ld.jpg'"
    >
      <fl-section-homepage-feature-title i18n="Section title">
        <p class="text-primary text-size-inherit font-weight-inherit">
          Make it real
        </p>
        with Freelancer
      </fl-section-homepage-feature-title>
      <fl-section-homepage-feature-top-left>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            The best talent
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            Discover reliable professionals by exploring their portfolios and
            immersing yourself in the feedback shared on their profiles.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-top-left>
      <fl-section-homepage-feature-top-right>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            Fast bids
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            Get quick, no-obligation quotes from skilled freelancers. 80% of
            jobs receive bids within 60 seconds. Your idea is just moments from
            reality.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-top-right>
      <fl-section-homepage-feature-bottom-left>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            Quality work
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            With Freelancer's talent pool of over
            {{ userCount$ | flAsync }} million professionals at your fingertips,
            you'll find quality talent to get what you need done.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-bottom-left>
      <fl-section-homepage-feature-bottom-right>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            Be in control
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            Stay in the loop while on the move. Chat with your freelancers and
            get real time updates with our mobile app. Anytime, anywhere.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-bottom-right>
      <fl-section-homepage-feature-footer
        i18n-footerCopy="Footer description"
        i18n-footerLink="Footer link"
        footerCopy="Make your dreams a reality."
        footerLink="Get started now"
        [footerUrl]="'/post-project'"
      >
      </fl-section-homepage-feature-footer>
    </fl-section-homepage-feature>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageMakeItRealComponent implements OnInit {
  private datastore = inject(Datastore);

  userCount$: Observable<string>;

  ngOnInit(): void {
    this.userCount$ = this.datastore
      .document<SiteStatsCollection>('siteStats')
      .valueChanges()
      .pipe(
        map(stat =>
          (stat.userCount / 1_000_000).toFixed(1).replace(/\.0$/, ''),
        ),
      );
  }
}
